<template>
    <div class="m-score">
        <h5 class="title"></h5>

        <div class="view">
            <div class="ui-select">
                <div class="select-now"> {{ mpl_list[evt_now].name }}{{ mpl_list[evt_now].schedule }} <div class="u-btn trriger" @click="listActive=!listActive"></div></div>
                <ul v-show="listActive">
                    <li v-for="(item,index) in mpl_list" :key="index"
                    @click="evt_now = index;listActive=false;reflashView(item.id)">{{ item.name }}{{ item.schedule }}</li>
                </ul>
            </div>

            <div class="result-view">
                <div class="m-result">
                    <div class="timeline">
                        <div class="wrapper">
                            <ul :style="{'left' : cnt * -116 + 'px'}">
                                <li v-for="(item,index) in _week_list" :key="index"
                                :class="{'act' : wid == item.id}"
                                @click="wid = item.id;reflashScore(item.id);">{{ item.weekName }}</li>
                            </ul>
                        </div>

                        <div class="u-btn next" :class="{'disabled' : _week_list.length <= 6 || cnt == _week_list.length-6}" @click='swiperNext'></div>
                        <div class="u-btn prev" :class="{'disabled' : _week_list.length <= 6 || cnt == 0}" @click='swiperPrev'></div>
                    </div>

                    <div class="race-view">
                        <vuescroll :ops="ops">
                        <div class="race-item" :class="'state-' + item.state" v-for="(item,index) in race_data" :key="index">
                            <div class="time">
                                <p class="date">{{ timeFormat(new Date(item.time),'YYYY-mm-dd') }}</p>
                                <p class="clock">{{ timeFormat(new Date(item.time),'HH:MM') }}</p>
                                <p class="state">
                                    <span v-if="item.state == 0">待开始</span>
                                    <span v-if="item.state == 1">直播中</span>
                                    <span v-if="item.state == 2">已结束</span>
                                </p>
                            </div>

                            <div class="match-result">
                                <p class="team-name">{{ item.team1Name }}</p>
                                <div class="score">
                                    <div class="score-item" :class="{ 'winner' : item.team1Score > item.team2Score}">{{item.team1Score}}</div>
                                    <div class="score-item" :class="{ 'winner' : item.team1Score < item.team2Score}">{{item.team2Score}}</div>
                                </div>
                                <p class="team-name">{{ item.team2Name }}</p>
                            </div>

                            <div class="report">
                                <div class="video" v-if="item.video"><a :href="item.video" target="_blank" rel="noopener noreferrer"></a></div>
                                <div class="news" v-if="item.news"><a :href="item.news" target="_blank" rel="noopener noreferrer"></a></div>
                            </div>
                        </div>
                        </vuescroll>
                    </div>
                </div>
                <div class="m-result-score">
                    <div class="team-view">
                        <vuescroll :ops="ops">
                        <div class="team-item" v-for="(item,index) in team_data" :key="index" :class="'rank-' + (index + 1)">
                            <div class="rank">
                                <em v-if="index < 3" class="icon" :class="'icon-' + (index + 1)"></em>
                                <span v-else>{{ (index + 1) }}</span>
                            </div>
                            <div class="team-info">
                                <img :src="item.temaLogo" :alt="item.teamName" srcset="">
                                <span>{{ item.teamName }}</span>
                            </div>
                            <div class="result">{{ item.win }}/{{ item.loss }}</div>
                            <div class="score-1">{{ item.less }}</div>
                            <div class="score-2">{{ item.score }}</div>
                        </div>
                        </vuescroll>
                    </div>
                </div>
            </div>
        </div>

        <div class="m-ad">
            <div class="ad-swiper">
                <div class="swiper">
                    <swiper ref="interSwiper" :options="swiperOptions" v-if="ready">
                        <swiper-slide
                        v-for="(item,index) in ads_list" :key="index"               
                        >
                            <div class="ad-item">
                                <a :href="item.url" target="_blank" rel="noopener noreferrer">
                                    <img :src="item.logo" alt="" srcset="">
                                </a>
                            </div>
                        </swiper-slide>
                                        
                    </swiper>

                    <ul class="swiper-pagination">
                        <li v-for="(item,index) in ads_list" :key="index" :class="{'act' : $refs.interSwiper&&$refs.interSwiper.swiper.activeIndex==index}"></li>
                    </ul> 
                </div>  
            </div>        
        </div>
    </div>
</template>

<script>
import vuescroll from 'vuescroll';

export default {
    components: {
        vuescroll,
    },
    computed: {
        swiper () {
            return this.$refs.interSwiper.swiper
        }
    },            
    data (){
        return {
            evt_list : [
                { name : '2022 MSPL 夏季常规赛' , id : 1,},
                { name : '2022 MSPL 夏季常规赛' , id : 2,},
                { name : '2022 MSPL 夏季常规赛' , id : 3,},
                { name : '2022 MSPL 夏季常规赛' , id : 4,},
                { name : '2022 MSPL 夏季常规赛' , id : 5,},
            ],
            evt_now : 0,
            mid : 1,
            wid : 1,
            listActive : false,
            ads_list : [],
            race_data : [],
            team_data : [],
            ready : false,
            ops: {
                rail: {
                    opacity: 1,
                    background : '#000',
                    size: '12px',
                },
                bar: {
                    background: '#2b4d69',
                    keepShow : true,
                    size: '12px',
                }
            },
            swiperOptions: {
                // pagination: {
                //     el: '.swiper-pagination',
                // },
                observer:true, // 修改swiper自己或子元素时，自动初始化swiper
                observeParents:true, // 修改swiper的父元素时，自动初始化swiper
                paginationClickable: true,
                autoplay: {// 自动滑动
                    delay: 3000, //1秒切换一次
                    disableOnInteraction: false
                },          
            },
            cnt : 0,
            _week_list : [],                         
        }
    },  
    created (){
        let vm = this;

        let mid_filter = this.mpl_list.filter(function(e){
            return e.isDefault == true
        });

        this.mid = mid_filter ? mid_filter[0].id : this.mpl_list[0].id;

        let week_filter = this.week_list.filter(function(e){
            return e.current == true
        });

        this.wid = week_filter.length ? week_filter[0].id : this.week_list[0].id;

        let _i = 0;
        for(var i = 0 ; i < this.week_list.length;i++){
            if(vm.wid == vm.week_list[i].id){
                _i = i;
            }
        }
        this.cnt = Math.ceil(_i/6);

        //this.wid = this.week_list[0].id;

        this._week_list = this.week_list;
    },
    props :{
        'active' : {
            default : false,
        },
        mpl_list : {
            default: () => [],
        },
        week_list : {
            default: () => [],
        },          
    },    
    watch : {
        active (val){
            if(val && !this.ready){
                this.render_ads ();
                this.render_score ();
                this.render_team ();       
            }
        },
    },      
    methods : {
        render_ads (){
            let vm = this;
            this.$axios.get(this.$ajax_url_map.ads)
            .then(
                res => {
                    this.ads_list = res
                    this.ready = true
                    //this.swiper.update()
                    setTimeout(function(){
                        vm.swiper.update()
                    },200)
                },
            )
        },
        render_score (){
            this.$axios.get(this.$ajax_url_map.score_race,{
                params : {
                    mid : this.mid,
                    wid : this.wid
                }                
            })
            .then(
                res => {
                    //this.race_data = res
                    let list_1 = res.filter(function(e){
                        return e.state == 1;
                    })

                    let list_0 = res.filter(function(e){
                        return e.state != 1;
                    })
                    
                    let list_2 = res.filter(function(e){
                        return e.state == 2;
                    })                    

                    this.race_data = list_1.concat(list_0);                    
                },
            )
        },
        render_team (){
            this.$axios.get(this.$ajax_url_map.score_team,{
                params : {
                    mid : this.mid,
                }                  
            })
            .then(
                res => {
                    this.team_data = res
                },
            )
        },
        get_week(id){
            this.$axios.get(this.$ajax_url_map.week_list,{
                params : {
                    mid : this.mid,
                }                  
            })
            .then(
                res => {
                    this._week_list = res;
                    this.wid = this._week_list[0].id;
                    this.render_score ();
                },
                rej => {

                }
            );
        },
        reflashView (id){
            this.mid = id;
            this.cnt = 0;            
            this.render_team ();
            this.get_week();   
        },
        reflashScore (wid){
            this.wid = wid;
            this.render_score ();
        },
        timeFormat(date, fmt){
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;    
        },
        swiperNext() {
            if(this.cnt >= this._week_list.length - 6)return;
            this.cnt += 1;
        },
        swiperPrev() {
            if(this.cnt == 0)return;
            this.cnt -= 1;
        },                                 
    }
}
</script>

<style scoped>

    .m-score{
        margin-top: 155px;
    }

    .title{
        width: 238px;
        height: 56px;
        margin-bottom: 40px;
        background-image: url(~@/assets/images/score/title.png);
    }

    .ui-select{
        position: relative;
        width: 282px;
        font-size: 20px;
        color: #e6d098;        
    }

    .select-now{
        position: relative;
        width: 282px;
        height: 52px;
        line-height: 50px;
        padding-left: 15px;
        box-sizing: border-box;
        border: 1px solid #d4c292;
        border-radius: 25px;
        background-color: #0e2037;
        z-index: 3;
    }

    .trriger{
        position: absolute;
        top: 50%;
        right: 20px;
        width: 19px;
        height: 16px;
        transform: translateY(-50%);
        background-image: url(~@/assets/images/score/icon-select.png);
    }

    .ui-select ul{
        position: absolute;
        left: 50%;
        top: 22px;
        width: 280px;
        padding-top: 47px;
        background-color: #0e2037;
        border: 1px solid #d4c292;
        transform: translateX(-50%);
        z-index: 2;
    }

    .ui-select li{
        padding-left: 15px;
        margin-bottom: 20px;
        cursor: pointer;
    }

    .ui-select li:hover{
        color: #ffd247;
    }

    .result-view{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .result-view .m-result{
        width: 776px;
        height: 862px;
        background-image: url(~@/assets/images/score/bg-result.png);
    }

    .result-view .m-result-score{
        width: 596px;
        height: 863px;
        background-image: url(~@/assets/images/score/bg-score.png);
    }

    .timeline{
        position: relative;
        width: 696px;
        height: 84px;
        margin: 0 auto;
    }

    .s-timeline{
        height: 84px;
    }

    .u-btn.prev{
        position: absolute;
        left: -46px;
        top: -1px;
        width: 46px;
        height: 85px;
        background-image: url(~@/assets/images/score/btn-prev.png);
    }

    .u-btn.next{
        position: absolute;
        right: -46px;
        top: -1px;
        width: 46px;
        height: 85px;
        background-image: url(~@/assets/images/score/btn-next.png);
    }    

    .timeline .wrapper{
        position: relative;
        width: 696px;
        height: 84px;
        margin: 0 auto;
        overflow: hidden;
    }
    
    .timeline ul{
        position: absolute;
        left: 0;
        top: 0;
        width: max-content;
        height: 84px;
        /* display: flex; */
        transition: all .3s ease-in;
    }

    .timeline li,
    .timeline .trriger{
        float: left;
        width: 116px;
        height: 84px;
        line-height: 84px;
        text-align: center;
        font-size: 20px;
        color: #cfb880;
        background-image: url(~@/assets/images/score/bg-item.png);
        cursor: pointer;
    }

    .timeline li.act,
    .timeline .trriger.act{
        background-image: url(~@/assets/images/score/bg-item-active.png);
    }

    .m-ad{
        width: 1400px;
        height: 280px;
        margin-top: 80px;
        background-color: #182736;
    }

    .m-ad .ad-item{
        position: relative;
        width: 1400px;
        height: 280px;        
    }

    .ad-item a{
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
    }

    .ad-item img{
        position: absolute;
        left: 50%;
        top: 50%;
        max-width: 1400px;
        max-height: 280px;
        transform: translate(-50%,-50%);
    }

    .race-view{
        margin: 14px 8px 0 45px;
        height: 750px;
    }

    .race-item{
        display: flex;
        /* justify-content: space-between; */
        align-items: center;
        margin-right: 37px;
        padding-top: 45px;
        padding-bottom: 30px;
        border-bottom: 1px solid #244e79;       
        font-size: 18px;
    }

    .race-item.state-1{
        color: #ffa92e;
    }

    .race-item.state-0{
        color: #8ec7ff
    }

    .race-item.state-2{
        color: #3c648b;
    }    

    .race-item .time{
        margin-left: 12px;
        margin-right: 45px;
        text-align: center;
    }

    .race-item .date{
        
    }

    .race-item .clock{
        font-size: 40px;
        font-weight: 700;
    }

    .race-item.state-1 .clock{
        color: #ffe9a5;
    }    

    .race-item .match-result{
        display: flex;
        align-items: center;
    }

    .match-result .score{
        display: flex;
        
    }

    .match-result .team-name{
        width: 102px;
        margin: 0 10px;
        text-align: center;
    }

    .match-result .score-item{
        width: 48px;
        height: 77px;
        margin: 0 5px;
        line-height: 77px;
        font-size: 40px;
        font-weight: 700;
        color: #ffffff;
        text-align: center;
        background-image: url(~@/assets/images/score/bg-normal.png);
    }

    .match-result .score-item.winner{
        background-image: url(~@/assets/images/score/bg-win.png);
    }

    .report {
        margin-left: 55px;
    }

    .report a{
        display: block;
        width: 100%;
        height: 100%;
    }

    .report .video{
        width: 112px;
        height: 38px;
        margin: 4px 0;
        background-image: url(~@/assets/images/score/btn-video.png);
    }

    .report .video:hover{
        background-image: url(~@/assets/images/score/btn-video_act.png);
    }

    .report .news{
        width: 112px;
        height: 38px;
        margin: 4px 0;
        background-image: url(~@/assets/images/score/btn-result.png);
    }
    
    .report .news:hover{
        background-image: url(~@/assets/images/score/btn-result_act.png);
    }
    
    .team-view{
        width: 578px;
        height: 660px;
        margin: 0 auto;
        padding-top: 170px;
    }

    .team-item{
        display: flex;
        /* justify-content: space-around; */
        align-items: center;
        width: 100%;
        height: 107px;
        font-size: 20px;
        color: #fff;
        text-align: center;
    }

    .team-item.rank-1{
        background-image: url(~@/assets/images/score/r-1.png);
    }

    .team-item.rank-2{
        background-image: url(~@/assets/images/score/r-2.png);
    }
    
    .team-item.rank-3{
        background-image: url(~@/assets/images/score/r-3.png);
    }

    .team-item .rank{
        width: 47px;
        margin: 0 10px 0 30px;
    }

    .team-item .team-info{
        /* margin: 0 40px 0 20px; */
        width: 175px;
        margin-right: 15px;
        text-align: center;
    }

    .team-item .result{
        width: 70px;
        margin-right: 40px;
        text-align: center;
    }

    .team-item .score-1{
        width: 70px;
        margin-right: 30px;
        text-align: center;
    }

    .team-item .score-2{
        width: 70px;
    }
    
    .team-item .icon{
        display: block;
        width: 47px;
        height: 56px;
        background-repeat: no-repeat;
    }

    .team-item .icon.icon-1{
        background-image: url(~@/assets/images/score/icon-1.png);
    }

    .team-item .icon.icon-2{
        background-image: url(~@/assets/images/score/icon-2.png);
    }
    
    .team-item .icon.icon-3{
        background-image: url(~@/assets/images/score/icon-3.png);
    }
    
    .team-info img{
        width: 30px;
        height: 30px;
        vertical-align : middle;
    }

    .swiper{
        position: relative;
    }

    .swiper-pagination {
        position: absolute;
        right: 30px;
        bottom: 16px;
    }

    .swiper-pagination li{
        display: inline-block;
        width: 22px;
        height: 22px;
        margin: 0 8px;
        background-image: url(~@/assets/images/score/nav.png);
        background-repeat: no-repeat;
        background-position: center;
    }

    .swiper-pagination li.act{
        background-image: url(~@/assets/images/score/nav_act.png);
    }
</style>




// WEBPACK FOOTER //
// src/components/page/score.vue